import React from 'react';
export var CartContext = /*#__PURE__*/React.createContext({
  cart: null
});
export var CartContextProvider = CartContext.Provider;